module.exports = __webpack_public_path__ + "static/media/facebook_mobile_blue.f84b8d1b.svg";